import { Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Typography } from "@material-ui/core";
import { DateField, GeneratePassword, NumberField, PriceField, SelectField, SubmitButton, TextField, UploadField } from "@microrealestate/commonui/components";
import { FieldArray, Form, Formik } from "formik";
import useTranslation from "next-translate/useTranslation";
import { useState, useEffect, useCallback, useContext, useMemo } from "react";
import useDialog from "../../hooks/useDialog";
import { StoreContext } from "../../store";
import { ADMIN_ROLE, ROLES, SUPERADMIN_ROLE } from "../../store/User";
import DeleteIcon from '@material-ui/icons/Delete';
import { useRouter } from "next/router";
import * as Yup from 'yup';
import { toJS } from "mobx";
import { setOrganizationId } from "../../utils/fetch";

const validationSchema = (t) => Yup.object().shape({
  fullName: Yup.string().required(t("Name is a required field")),
});

const initValues = (data, t) => {
  return {
    id: data._id,
    fullName: data.fullName || '',
    email: data.email || '',
    role: data.role,// t(data.role) || '',
  }
}

function EditLandlordDialog({
  title,
  open,
  setOpen,
  onSubmit
}) {
  const { t } = useTranslation('common');
  const store = useContext(StoreContext);
  const router = useRouter();

  const initialValues = useMemo(() => {
    const initialValues = initValues(open, t)
    return initialValues;
  }, [open])

  const handleClose = useCallback(() => setOpen(false), [setOpen]);
  const _onSubmit = useCallback(
    async (landlordPart) => {
      const selectedUser = !!open ? open : null
      const memberList = store.organization.selected.members

      const updatedUser = {
        ...selectedUser,
        scopeProperty: selectedUser.scopeProperty.map(scope => scope.id),
        fullName: landlordPart.fullName,
        // email: landlordPart.email,
      }

      const updatedMember = {
        name: updatedUser.fullName,
        email: updatedUser.email,
        role: updatedUser.role,
        userId: updatedUser._id
      }
      const newMemberList = memberList.reduce((acc, member) => {
        if (member.role === "landlord") {
          acc.push(updatedMember)
        } else {
          acc.push(member)
        }
        return acc
      }, []);

      const { status: statusUpdatedUser, data: dataUser } = await store.user.updateUser(
        updatedUser._id,
        updatedUser.email,
        updatedUser.fullName,
        updatedUser.role,
        updatedUser.isEnabled,
        updatedUser.scopeProperty
      );

      if (statusUpdatedUser !== 200) {
        store.pushToastMessage({
          message: t("Something went wrong"),
          severity: 'error',
        });
      } else {
        store.pushToastMessage({
          message: t("Success edit landlord's account"),
          severity: 'success',
        });
      }

      await onSubmit({
        members: newMemberList,
      });
      handleClose()
      await router.push(
        `/settings`
      );

    }, [open, store, handleClose, t, onSubmit, router])

  return (

    <Dialog
      open={!!open}
      onClose={handleClose}
      aria-labelledby="edit-landlord-dialog"
    >
      <Box p={1}>
        <DialogTitle>{title}</DialogTitle>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema(t)}
          onSubmit={_onSubmit}
        >
          {({ values, isSubmitting }) => {
            return (
              <Form autoComplete="off">
                <DialogContent>
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      <TextField label={t('Name')} name="fullName" />
                    </Grid>
                    <Grid item xs={8}>
                      <TextField label={t('Email')} name="email" disabled />
                    </Grid>
                    <Grid item xs={4}>
                      <TextField label={t('Role')} name="role" disabled />
                    </Grid>
                  </Grid>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} color="primary">
                    {t('Cancel')}
                  </Button>
                  <SubmitButton
                    label={t('Update')}
                  />
                </DialogActions>
              </Form>
            )
          }}
        </Formik>
      </Box>
    </Dialog>
  )
}

export default function useEditLandlordDialog() {
  return useDialog(EditLandlordDialog);
}